import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as service from '../../services/tables.service';
import {
    getTablesRequest,
    getTablesSuccess,
    setDownloadAllDetails,
    setTableModalData
} from '../slice';
import { ADD_TABLE_REQUEST, GENERATE_PDF_REQUEST, GET_TABLE_REQUEST, REMOVE_TABLE_REQUEST } from '../types';

function* getTablesRequestSaga(action) {
    try {
        const { hotelId, filter, active, data: tableData = [] } = action.payload;
        const offset = tableData.length;
        const res = yield service.fetch(hotelId, filter, active, offset);

        let data = res.rows?.reduce((cur, next) => {
            cur.push({ label: `Table-${next.tableNumber}`, value: next.id });
            return cur;
        }, []);
        data = tableData.concat(data);

        yield put(getTablesSuccess({ data, count: data.length, totalCount: res.totalCount }));
    } catch (error) {
        console.error('Failed to fetch tables ', error);
        toast.error(`Failed to fetch tables ${error.message}`);
    }
}

function* addTablesRequestSaga(action) {
    try {
        const { hotelId, count } = action.payload;
        yield service.add(hotelId, { count });
        toast.success('Tables added successfully');

        yield put(setTableModalData(false));
        yield put(getTablesRequest({ hotelId }));
    } catch (error) {
        console.error('Failed to add tables ', error);
        yield put(setTableModalData(false));
        toast.error(`Failed to add tables ${error.message}`);
    }
}

function* removeTablesRequestSaga(action) {
    try {
        const { hotelId, count } = action.payload;
        yield service.remove(hotelId, { count });
        toast.success('Tables removed successfully');

        yield put(setTableModalData(false));
        yield put(getTablesRequest({ hotelId }));
    } catch (error) {
        console.error('Failed to remove tables ', error);
        yield put(setTableModalData(false));
        toast.error(`Failed to remove tables ${error.message}`);
    }
}

function* generatePdfRequestSaga(action) {
    try {
        const payload = action.payload;
        const response = yield call(service.generate, payload);

        // Convert response to blob
        const blob = new Blob([response], { type: 'application/pdf' });

        // Trigger download
        const url = window.URL.createObjectURL(blob);
        const pdf = document.createElement('a');
        pdf.href = url;
        pdf.download = 'table-qr-codes.pdf';
        document.body.appendChild(pdf);
        pdf.click();
        pdf.remove();
        window.URL.revokeObjectURL(url);

        toast.success('PDF generated successfully');
        yield put(setDownloadAllDetails({ show: false, start: 0, end: 0 }));
    } catch (error) {
        console.error('Failed to generate pdf for tables ', error);
        toast.error(`Failed to generate pdf ${error.message}`);
    }
}

export default function* tablesSaga() {
    yield all([takeLatest(GET_TABLE_REQUEST, getTablesRequestSaga)]);
    yield all([takeLatest(ADD_TABLE_REQUEST, addTablesRequestSaga)]);
    yield all([takeLatest(REMOVE_TABLE_REQUEST, removeTablesRequestSaga)]);
    yield all([takeLatest(GENERATE_PDF_REQUEST, generatePdfRequestSaga)]);
}
